import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/university/skills/')({

}).lazy(() => import('./index.lazy').then((d) => d.Route));
